import { css } from 'styled-components'
import featheredShape from 'styles/featheredShape'
import type { CSS } from 'types/style'

export type FeatherProps = {
  edits: {
    feather?: boolean
    featherStrength?: number
    circle?: boolean
    borderRadius?: number
  }
  width?: number
  height?: number
}

export const feather = ({ edits, width, height }: FeatherProps): CSS => {
  const maskUrl = featheredShape(edits, width, height)
  return css`
    mask: url(${`"${maskUrl}"`});
    -webkit-mask: url(${`"${maskUrl}"`});
    background-size: cover;
    mask-size: 100% 100%;
    -webkit-mask-size: 100% 100%;
    border-radius: 0;
    border: none;
  `
}

export const itemFeather = (
  edits: FeatherProps['edits'],
  width?: number,
  height?: number,
  type?: 'image' | 'shape',
) => {
  const shouldFeather =
    edits?.feather && edits?.featherStrength && edits?.featherStrength > 0
  if (!shouldFeather) return undefined
  const isImage = type === 'image'

  return isImage ? feather({ edits, width, height }) : feather
}
